module.exports = __webpack_public_path__ + "static/img/akum_800_160.74d5490.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/akumulator/akum_800_160.svg
// module id = 6Rtc
// module chunks = 1